import { webComponentsApi } from '../config/urlConfig';
import { request } from '../utils/request';

interface webComponentQuery {
  params?: webComponentParms,
  page?: number,
  limit?: number,
  domainModelCode: string
}
interface webComponentParms {
  _id?: string,
  title?: string,
  comment?: string,
  publish?: string,
  status?: boolean,
  lange?: string,
  lastModifyUser?: string,
  lastModifyTime?: string
}

/**
 * 分页查询组件设计
 * @param data
 */
export const getWebComponents = (data: webComponentQuery) =>
  request({
    url: `${webComponentsApi}/webComponent/list`,
    method: "post",
    data
  })

  /**
 * 查询所有组件
 * @param data
 */
export const getAllWebComponents = (data?: webComponentQuery) =>
  request({
    url: `${webComponentsApi}/webComponent/listAll`,
    method: "post",
    data
  })

/**
* 查询所有组件定义ast
* @param data
*/
export const getComponentAtsAll = (data?: webComponentQuery) =>
  request({
    url: `${webComponentsApi}/webComponent/astAll`,
    method: "post",
    data
  })

/**
 * @description: 更新组件
 * @param {any} data
 * @return {*}
 */
export const updateWebComponent = (data: webComponentQuery) =>
  request({
    url: `${webComponentsApi}/webComponent/update`,
    method: "post",
    data
  })

/**
 * @description: 删除组件
 * @param {any} data
 * @return {*}
 */
export const deleteWebComponent = (data: webComponentQuery) =>
  request({
    url: `${webComponentsApi}/webComponent/delete`,
    method: "post",
    data
  })

/**
 * @description: 新增组件
 * @param {any} data
 * @return {*}
 */
export const insertWebComponent = (data: webComponentQuery) =>
  request({
    url: `${webComponentsApi}/webComponent/insert`,
    method: "post",
    data
  })


  export const genTailwindcss = async (data) => request( {
    url: `${webComponentsApi}/webComponent/genTailwindcss`,
    method: 'POST',
    data,
  });

/**
 * 分页查询页面设计
 * @param data
 */
export const getWebPageList = (data: webComponentQuery) =>
  request({
    url: `${webComponentsApi}/webPage/list`,
    method: "post",
    data
  })

/**
 * 查询所有页面
 * @param data
 */
export const getAllWebPages = (data?: webComponentQuery) =>
  request({
    url: `${webComponentsApi}/webPage/listAll`,
    method: "post",
    data
  })

/**
 * @description: 新增页面
 * @param {any} data
 * @return {*}
 */
export const insertWebPage = (data: any) =>
  request({
    url: `${webComponentsApi}/webPage/insert`,
    method: "post",
    data
  })


/**
 * @description: 更新页面
 * @param {any} data
 * @return {*}
 */
export const updateWebPage = (data: webComponentQuery) =>
  request({
    url: `${webComponentsApi}/webPage/update`,
    method: "post",
    data
  })

/**
 * @description: 删除页面
 * @param {any} data
 * @return {*}
 */
export const deleteWebPage = (data: webComponentQuery) =>
  request({
    url: `${webComponentsApi}/webPage/delete`,
    method: "post",
    data
  })


/**
 * @description: 查询多轮历史记录
 * @param {any} data
 * @return {*}
 */
export const queryPageDesignHistoryRecord = (data) =>
  request({
    url: `${webComponentsApi}/multiWheel/queryPageDesignHistoryRecord`,
    method: "post",
    data
  })


/**
 * @description: 查询多轮历史记录
 * @param {any} data
 * @return {*}
 */
export const queryPageDesignHistoryStorage = (data) =>
  request({
    url: `${webComponentsApi}/multiWheel/queryPageDesignHistoryStorage`,
    method: "post",
    data
  })



